/**
 * @desc 去重
 * @param list
 */
export function getUniqueList<T>(arr: T[], comparer: (a: T, b: T) => boolean): T[] {
    return arr.filter((item, index, self) => {
        for (let i = 0; i < index; i++) {
            if (comparer(item, self[i])) {
                return false;
            }
        }
        return true;
    });
}

/**
 * @desc 从array中查找符合条件的对象元素,简要版
 * @param
 */
export function find(array: any[] | null, predicate: (item: any, index: number) => boolean) {
    if (array == null) {
        return;
    }

    for (let i = 0, j = array.length; i < j; i++) {
        if (predicate(array[i], i)) {
            return array[i];
        }
    }
}

export const findLastIndex = (list: any[], fnc: (item: any) => boolean) => {
    if (!Array.isArray(list)) {
        return -1;
    }
    for (let index = list.length - 1; index >= 0; index--) {
        if (fnc(list[index])) {
            return index;
        }
    }
    return -1;
};

/**
 * 打乱数组顺序
 * @param {*} arr
 * return 被打算顺序的新数组
 */
export const shuffle = (arr: any[] = []) => {
    if (!(arr instanceof Array)) {
        return arr;
    }
    const newArr = arr.concat();
    for (let i = newArr.length - 1; i >= 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[randomIndex]] = [newArr[randomIndex], newArr[i]];
    }
    return newArr;
};
